export const MAPPING_ROUTE_OBJECT = {
  store: 'Store',
  booking: 'Booking',
  record: 'Record',
  menu: 'StoreMenu',
  retail: 'StoreRetail',
  retailProduct: 'RetailMenuDetail',
  detail: 'RecordDetail', // 服務與商品的交易明細頁面
  bookingDetail: 'BookingDetail', // 服務預約詳情
  retailOrderDetail: 'RetailOrderDetail', // 商品訂購詳情
  profile: 'UserProfile',
  formDetail: 'FormDetail', // 問卷
  valueCard: 'UserValueCard', // 票卡頁面
  voucher: 'UserVoucher', // 優惠券頁面
  buy: 'Buy', // 店販結帳頁面
  profileEditor: 'ProfileEditor', // 用戶資料編輯頁面
  login: 'UserLogin',
  terms: 'Terms',
}
